import { JobApi } from 'api-typings/common/common';
import { Job } from './jobs.model';

export function transformJob(job: JobApi): Job {
  if (!job.name) {
    throw new ReferenceError(`Job missing name.`);
  }

  return {
    id: job.id,
    name: job.name,
    local: job.local || false,
  };
}
